// بسته i18n ققنوس (AP-008، ADR-015): i18next با منابع fa (پیش‌فرض)، en و ar و یک فضای نام به ازای ماژول.
import i18next, { type i18n as I18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { NAMESPACES, resources, type Namespace } from './resources';

export { I18nextProvider, Trans, useTranslation } from 'react-i18next';
export type { TFunction } from 'i18next';
export { errorMessageKey, ERROR_CODE_MESSAGE_KEYS } from './errors';
export { NAMESPACES, resources, type Namespace };

export const DEFAULT_LANGUAGE = 'fa';
export const SUPPORTED_LANGUAGES = ['fa', 'en', 'ar'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

/** زبان‌های راست‌به‌چپ. */
export function isRtl(language: string): boolean {
  const base = language.split('-')[0];
  return base === 'fa' || base === 'ar';
}

/** مقدار هدر Accept-Language برای API (عنوان ProblemDetails به همین زبان ترجمه می‌شود). */
export function acceptLanguage(language: string): string {
  const base = language.split('-')[0] ?? DEFAULT_LANGUAGE;
  return base === 'fa' ? 'fa-IR' : base;
}

export interface CreateI18nOptions {
  language?: Language;
}

/**
 * ساخت نمونه مستقل i18next (هر اپ و هر تست نمونه خودش را دارد). init همگام است چون منابع در بسته‌اند.
 * زبان ناموجود به فارسی برمی‌گردد؛ کلید ناموجود در en/ar از fa پر می‌شود.
 */
export function createPhoenixI18n(options: CreateI18nOptions = {}): I18nInstance {
  const instance = i18next.createInstance();
  void instance.use(initReactI18next).init({
    resources,
    lng: options.language ?? DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    ns: [...NAMESPACES],
    defaultNS: 'common',
    fallbackNS: 'common',
    interpolation: { escapeValue: false },
    returnNull: false,
    initAsync: false,
    showSupportNotice: false,
  });
  return instance;
}
